import React from "react";
import MyNavbar from "./components/my-navbar/my-navbar.component";
import MyCarousal from "./components/my-carousal/my-carousal.component";
import MyTitleMessage from "./components/title-message/title-message.component";
import About from "./pages/about/about.component";
import Skills from "./pages/skills/skills.component";
import Blog from './pages/blog';
import Container from "react-bootstrap/Container";
import TimeLine from "./components/projects-timeline/projects-timeline.component";
import Experience from "./pages/experience/experience.component";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";
import ContactForm from "./pages/contact-form/contact-form.component";
import { Parallax } from "react-parallax";
import FooterPanel from "./components/footer/footer.component";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import "./App.css";

import consoleBlog from './blogs/console';
// import microFrontendBlog from "./blogs/microfrontends";

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <div className="App" style={{ position: "relative" }}>
            <MyCarousal />
            <MyTitleMessage />
            <MyNavbar />
            <div>
              <Parallax
                blur={{ min: -30, max: 30 }}
                bgImage={require("./assets/img/parallex/background.webp")}
                bgImageAlt=""
                strength={-200}
              >
                <div>
                  <Container id="about" className="container-box rounded">
                    <Fade duration={500}>
                      <About />
                    </Fade>
                  </Container>
                </div>
              </Parallax>
            </div>
            <Container id="skills" className="container-box rounded">
              <Slide bottom duration={500}>
                <hr />
                <Skills />
              </Slide>
            </Container>

            <Container id="experience" className="container-box rounded">
              <Fade duration={500}>
                <hr />
                <Experience />
              </Fade>
            </Container>

            <Container id="projects" className="container-box rounded">
              <Slide bottom duration={500}>
                <hr />
                <TimeLine />
              </Slide>
            </Container>

            <Container id="contact" className="container-box rounded">
              <Fade duration={500}>
                <hr />
                <ContactForm />
              </Fade>
            </Container>

            <hr />
            <FooterPanel />
          </div>
        </Route>
        <Route path="/blog/console-is-much-more-than-log">
          <div className="blogContainer"><Blog markdown={consoleBlog} /></div>
        </Route>
        {/* <Route path="/blog/approach-to-micro-frontends">
          <div className="blogContainer"><Blog markdown={microFrontendBlog} /></div>
        </Route> */}
      </Switch>
    </Router>
  );
};

export default App;
